import logoFull from "./images/logoFull.png";

import home from "./icons/home.png";
import back from "./icons/back.png";
import close from "./icons/close.png";
import addPhoto from "./icons/addPhoto.png";
import settings from "./icons/settings.png";
import notify from "./icons/notify.png";
import calendar from "./icons/calendar.png";
import back2 from "./icons/back2.png";
import search from "./icons/search.png";
import tick from "./icons/tick.png";
import joined from "./icons/joined.png";
import waiting from "./icons/waiting.png";
import add from "./icons/add.png";
import iconLock from "./icons/iconLock.png";
import iconUser from "./icons/iconUser.png";
import iconShare from "./icons/iconShare.png";
import iconShareToFriend from "./icons/iconShareToFriend.png";
import iconNext from "./icons/iconNext.png";
import deleteKeyboard from "./icons/deleteKeyboard.png";
import backKeyboard from "./icons/backKeyboard.png";
import arrowThin from "./icons/arrowThin.png";
import trash from "./icons/trash.png";
import edit from "./icons/edit.png";
import burger from "./icons/burger.png";
import showHide from "./icons/showHide.png";

export const icons = {
  home,
  edit,
  back,
  close,
  addPhoto,
  settings,
  notify,
  calendar,
  back2,
  search,
  tick,
  joined,
  waiting,
  add,
  iconLock,
  iconUser,
  iconShare,
  iconShareToFriend,
  iconNext,
  deleteKeyboard,
  backKeyboard,
  arrowThin,
  trash,
  burger,
  showHide,
};

export const images = {
  logoFull,
};
